import * as Stitches from '@stitches/react';
import { styled } from '@gbm-tech/styles';

const InputContainerMD: Stitches.CSS = {
  height: '4.8rem',
  padding: '1rem 1.6rem',

  fontSize: '1.6rem',
  lineHeight: '2.8rem',
};

const InputContainerLG: Stitches.CSS = {
  height: '5.2rem',
  padding: '1.4rem 1.6rem',

  fontSize: '1.6rem',
  lineHeight: '2.8rem',
};

export const InputContainer = styled('input', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1.2rem',

  height: '4rem',
  width: '$$inputWidth',
  padding: '1.2rem 1.6rem',

  color: '$gray700',
  fontWeight: 400,
  fontSize: '1.4rem',
  lineHeight: '2.4rem',

  border: '1px solid $gray200',
  borderRadius: '4px',

  transition: 'all 0.4s ease-in-out',

  '&:focus': {
    borderColor: '$blue700',
  },

  '&::-webkit-input-placeholder': {
    color: '$gray700',
    opacity: 0.5,
  },

  variants: {
    full: {
      true: {
        width: '100%',
      },

      false: {
        width: '$$inputWidth',
      },
    },

    required: {
      true: {
        backgroundColor: 'red',
      },
      false: {
        backgroundColor: 'blue',
      },
    },

    inputSize: {
      sm: {},

      md: {
        ...InputContainerMD,
      },

      lg: {
        ...InputContainerLG,
      },
    },
  },
});

export const InputGroupContainer = styled('div', {
  width: '$$inputWidth',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',

  variants: {
    full: {
      true: {
        width: '100%',
      },

      false: {
        width: '$$inputWidth',
      },
    },
  },
});
